export default __webpack_public_path__ + "static/media/ship.40361a3b.svg";